import { useMutation, useQueryClient } from '@tanstack/react-query';

import { taskCommentsApi } from './api-handlers';
import { taskCommentsQueryKeys } from './query-keys';

import type { ICommentMessage } from '@entities/message';

export const useDeleteTaskCommentMutation = (taskId: string) => {
    const queryClient = useQueryClient();
    const queryKey = taskCommentsQueryKeys.list(taskId);

    return useMutation({
        mutationKey: taskCommentsQueryKeys.delete(taskId),
        mutationFn: (commentId: ICommentMessage['id']) =>
            taskCommentsApi.deleteTaskComment({ taskId, commentId }),
        onSuccess: async (data) => {
            await queryClient.cancelQueries({ queryKey, exact: true });
            queryClient.setQueryData(queryKey, data);
        },
    });
};
